<template></template>

<script>
import SimplePeer from "simple-peer";

export default {
    props: {
        value: { type: Object, default: () => ({}) }, // report
        peer: { type: SimplePeer, default: null },
    },
    data: () => ({
        intervalId: undefined,
        report: {
            audioLevel: 0,
        },
    }),
    methods: {
        init() {
            if (this.intervalId) clearInterval(this.intervalId);
            this.intervalId = setInterval(this.getStats, 50);
        },
        getStats() {
            this.peer?.getStats?.((error, /** @type {RTCStatsReport} */ report) => {
                let stats = Array.from(report.values());
                let { audioLevel = 0 } = stats.find((item) => item.type == "media-source" && item.kind == "audio") || {};

                this.report = { audioLevel };
            });
        },
    },
    watch: {
        peer() {
            this.init();
        },
        report() {
            this.$emit("input", this.report);
        },
    },
    mounted() {
        this.init();
    },
    beforeDestroy() {
        if (this.intervalId) clearInterval(this.intervalId);
    },
};
</script>

<style>
</style>